import React, { useEffect } from 'react';
import GridTime from './grid-time';

interface GridProps {
  startHour: Date;
  range: number;
  setHourY?: (y: number) => void;
}

const Grid: React.FunctionComponent<GridProps> = ({ range, startHour, setHourY }) => {
  return (
    <>
      {[...new Array(range).keys()].map((r) => (
        <div className="row" key={r}>
          <GridTime startHour={startHour} setHourY={setHourY} range={r} />
          <span className="content"></span>
        </div>
      ))}
    </>
  );
};

export default React.memo(Grid);
